import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const ProductCard = ({ product, showAddToCart = true }) => {
  const { addItem } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product, 1);
    toast.success('Prodotto aggiunto al carrello');
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };

  return (
    <Link 
      to={`/prodotti/${product.slug}`}
      className="group relative bg-white border border-border/50 rounded-xl overflow-hidden hover:shadow-hover transition-all duration-300"
      data-testid={`product-card-${product.id}`}
    >
      {/* Image */}
      <div className="aspect-square overflow-hidden bg-background">
        <img
          src={product.image_url || 'https://images.pexels.com/photos/7663192/pexels-photo-7663192.jpeg'}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {product.is_featured && (
          <span className="absolute top-3 left-3 bg-accent/90 text-accent-foreground px-2.5 py-1 rounded-full text-xs font-bold uppercase tracking-wider">
            In evidenza
          </span>
        )}
        {product.compare_price && product.compare_price > product.price && (
          <span className="absolute top-3 right-3 bg-primary text-white px-2.5 py-1 rounded-full text-xs font-bold">
            -{Math.round((1 - product.price / product.compare_price) * 100)}%
          </span>
        )}
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-heading font-semibold text-text-primary group-hover:text-primary transition-colors line-clamp-2">
          {product.name}
        </h3>
        
        <div className="mt-3 flex items-center justify-between">
          <div className="flex items-baseline gap-2">
            <span className="text-lg font-bold text-primary">
              {formatPrice(product.price)}
            </span>
            {product.compare_price && product.compare_price > product.price && (
              <span className="text-sm text-text-muted line-through">
                {formatPrice(product.compare_price)}
              </span>
            )}
          </div>
        </div>

        {showAddToCart && (
          <Button
            onClick={handleAddToCart}
            className="w-full mt-4 gap-2"
            size="sm"
            data-testid={`add-to-cart-${product.id}`}
          >
            <ShoppingCart className="w-4 h-4" />
            Aggiungi
          </Button>
        )}
      </div>
    </Link>
  );
};

export default ProductCard;
